<template>


  <div class="content content-fixed content-auth">
    <div class="container">
      <div class="media align-items-stretch justify-content-center ht-100p pos-relative">
        <div class="media-body align-items-center d-none d-lg-flex">
          <div class="mx-wd-600">
            <img src="../../assets/img/login.webp" class="img-fluid" alt="">
          </div>
          <div class="pos-absolute b-0 l-0 mg-b-40 mg-l-0">
            <h1 class="tx-color-01 tx-30 mg-b-0">Explore <br>the <br>things <br><span class="tx-primary">you love</span>.</h1>
          </div>
        </div><!-- media-body -->
        <div class="sign-wrapper mg-lg-l-50 mg-xl-l-60">
          <div class="wd-100p">
            <h3 class="tx-color-01 mg-b-5">Sign In</h3>
            <p class="tx-color-03 tx-16 mg-b-40">Welcome back! Please signin to continue.</p>

            <div class="form-group">
              <label>Email address</label>
              <input v-model="auth.username" type="email" class="form-control" placeholder="Enter your email address or username">
            </div>
            <div class="form-group">
              <div class="d-flex justify-content-between mg-b-5">
                <label class="mg-b-0-f">Password</label>
                <router-link to="/forgot-password" class="tx-13">Forgot password?</router-link>
              </div>
              <input v-model="auth.password" type="password" class="form-control" placeholder="Enter your passcode">
            </div>
            <button v-on:click="this.mixinLogin(this.auth);" class="btn btn-brand-02 w-100">Sign In</button>
            <div class="divider-text">or</div>
            <div class="d-grid gap-2">
              <button class="btn btn-outline-facebook btn-block">Sign In With Facebook</button>
              <button class="btn btn-outline-twitter btn-block">Sign In With Twitter</button>
            </div>
            <div class="tx-13 mg-t-20 tx-center">Don't have an account?
              <router-link to="/sign-up">Create an account</router-link>
            </div>
          </div>
        </div><!-- sign-wrapper -->
      </div><!-- media -->
    </div><!-- container -->
  </div><!-- content -->

  <AuthFooter/>


</template>

<script>

import footerScriptMixin from "@/mixins/footer-script";
import AuthFooter from "./AuthFooter.vue";
import authService from "../../mixins/auth-service";

export default {
  name: "Login",
  components: {
    AuthFooter

  },
  mixins: [footerScriptMixin, authService],
  data() {
    return {
      auth: {
        username: "",
        password: "",
        organizationAppId: this.orgAppId,
      }
    };
  },
  created() {
    this.footerScript();
  },
  methods: {}
};
</script>


<style>
@import '../../assets/css/dashforge.auth.css';
</style>
